import type {AxiosRequestConfig} from 'axios';

import {ResponseDto} from '@/models/dto/common/response';

import client from './client';

export const get = async <T>(
  url: string,
  params?: Record<string, unknown>,
  headers?: Record<string, string>,
  responseType?: AxiosRequestConfig['responseType']
): Promise<T> => {
  const config: AxiosRequestConfig = {params, headers, responseType};
  const response = await client.get<ResponseDto<T>>(url, config);

  if (response.data.status === 'success') {
    return response.data.data;
  } else {
    throw new Error(response.data.message || '서버 오류가 발생했습니다.');
  }
};

export const post = async <T, D = unknown>(url: string, data?: D, config?: AxiosRequestConfig): Promise<T> => {
  const response = await client.post<ResponseDto<T>>(url, data, config);

  if (response.data.status === 'success') {
    return response.data.data;
  } else {
    throw new Error(response.data.message || '서버 오류가 발생했습니다.');
  }
};

export const postFormData = async <T>(url: string, formData: FormData): Promise<T> => {
  const response = await client.post<ResponseDto<T>>(url, formData);

  if (response.data.status === 'success') {
    return response.data.data;
  } else {
    throw new Error(response.data.message || '서버 오류가 발생했습니다.');
  }
};
